import { type SanityStrings } from '@data/sanity/queries/types/site'

export const emptySiteStrings: SanityStrings = {
  loadingPageTitle: '',
  searchingText: '',
  noResultsText: '',
  languageSwitch: '',
  cartLink: '',
  featuredProducts: '',
  skipToContent: '',
  goHomeLabel: '',
  mobileMenuLabel: '',
  productOptionsHeading: '',
  productInStock: '',
  productLowStock: '',
  productOutOfStock: '',
  productDescriptionHeading: '',
  productFrameDimensionsHeading: '',
  productFrameDimensionsSizeMissing: '',
  productArtworkSizeLabel: '',
  productInnerFrameSizeLabel: '',
  productOuterFrameSizeLabel: '',
  productPassepartoutSizeLabel: '',
  productPassepartoutHoleSizeLabel: '',
  productPriceLabel: '',
  productPricePrefix: '',
  productSkuLabel: '',
  productIdLabel: '',
  productColorOptionLabel: '',
  productDiscountText: '',
  productPassepartoutHoleSize: '',
  productIncreaseQuantity: '',
  productDecreaseQuantity: '',
  productEnterQuantity: '',
  productNotLoggedIn: '',
  productTaxIncludedText: '',
  combinedListingLoadingText: '',
  combinedListingErrorText: '',
  combinedListingFrame: '',
  combinedListingFrameColor: '',
  combinedListingSize: '',
  combinedListingGlass: '',
  combinedListingNoGlass: '',
  combinedListingBackboard: '',
  combinedListingNoBackboard: '',
  combinedListingPassepartout: '',
  combinedListingArtworkSize: '',
  combinedListingNoPassepartout: '',
  combinedListingSpacer: '',
  combinedListingNoSpacer: '',
  combinedListingEmptyFrame: '',
  combinedListingPreviewSettingsTitle: '',
  combinedListingPreviewSettingsUploadLabel: '',
  combinedListingPreviewSettingsUploadDescription: '',
  combinedListingPreviewSettingsUploadError: '',
  combinedListingPreviewSettingsColorLabel: '',
  cartTitle: '',
  cartClose: '',
  cartEmpty: '',
  cartFrameSizeAttribute: '',
  cartPassepartoutSizeAttribute: '',
  cartArtworkSizeAttribute: '',
  cartPassepartoutHoleSizeAttribute: '',
  cartBackboardAttribute: '',
  cartGlassAttribute: '',
  cartPassepartoutAttribute: '',
  cartSpacerAttribute: '',
  cartVatSectionTitle: '',
  cartVatIdInputPlaceholder: '',
  cartVatIdError: '',
  cartInvalidVatIdError: '',
  cartCommentSectionTitle: '',
  cartCommentInputPlaceholder: '',
  cartSubtotal: '',
  cartDiscount: '',
  cartShipping: '',
  cartTotal: '',
  cartSubmit: '',
  cartAddToCartErrorMessage: [],
  carouselCounterText: '',
  carouselLeftArrowLabel: '',
  carouselRightArrowLabel: '',
  carouselDotLabel: '',
  buttonAddToCart: '',
  buttonRemove: '',
  buttonAccept: '',
  buttonLearnMore: '',
  buttonTryAgain: '',
  buttonLoadMore: '',
  buttonUnavailable: '',
  buttonWaiting: '',
  buttonLoading: '',
  buttonCreatingProduct: '',
  buttonAdding: '',
  buttonUpdating: '',
  buttonSubmitting: '',
  buttonEdit: '',
  buttonDelete: '',
  buttonCancel: '',
  buttonSignup: '',
  buttonLogin: '',
  buttonSeeMore: '',
  buttonSeeOptions: '',
  emailAddress: '',
  emailAddressPlaceholder: '',
  emailMissing: '',
  emailInvalid: '',
  firstName: '',
  firstNamePlaceholder: '',
  firstNameMissing: '',
  lastName: '',
  lastNamePlaceholder: '',
  lastNameMissing: '',
  fullName: '',
  fullNamePlaceholder: '',
  fullNameMissing: '',
  phoneNumber: '',
  phoneNumberPlaceholder: '',
  phoneNumberMissing: '',
  phoneNumberInvalid: '',
  company: '',
  companyPlaceholder: '',
  message: '',
  messagePlaceholder: '',
  blogPostReadMore: '',
  blogPostBy: '',
  teamMemberCardLinkedIn: '',
  teamMemberCardBlogArticles: '',
}
